import axios from 'axios';

import { getJwt, getPrinterInfo, getSession } from './persistData';
import { BASE_URL } from './constants';

const base = BASE_URL;

const getHeaders = async () => {
  const token = await getJwt();
  if (token) {
    const header = {};
    header.authorization = `Bearer ${token}`;
    return header;
  }
  return null;
};

export const fetchEngagements = async (params = { sessionId: getSession() }) => {
  // eslint-disable-next-line no-console
  console.log(`Fetching  ${params.ruleType || 'all'} engagements `);
  if (
    params?.sessionId ||
    (params?.appInstanceId && params?.property && params?.locale && params?.location)
  ) {
    const printerInfo = getPrinterInfo();
    if (printerInfo.device_uuid && printerInfo.product_number) {
      params = {
        ...params,
        device_uuid: printerInfo.device_uuid,
        product_number: printerInfo.product_number,
        printer_sessionid: printerInfo.printer_sessionId,
        total_printers: printerInfo.total_printers,
        is_hpx_scan_supported: printerInfo.is_hpx_scan_supported
      };
    }
    console.log('Printer details: ', printerInfo, 'Params: ', params);
    const result = await axios({
      url: `${base}/engagements/engagement`,
      method: 'POST',
      headers: await getHeaders(),
      data: {
        ...params
      }
    });
    console.log(result, 'result Data');
    return result.data;
  } else {
    return [];
  }
};

export const updateTile = async (engagementId, payload) => {
  return axios({
    url: `${base}/engagements/${engagementId}`,
    method: 'PUT',
    headers: await getHeaders(),
    data: {
      cec_session_id: getSession(),
      ...payload
    }
  });
};

export const resetTiles = async () => {
  return axios({
    url: `${base}/engagements`,
    method: 'DELETE',
    headers: await getHeaders(),
    data: {
      cec_session_id: getSession()
    }
  });
};

export const cecClosed = async () => {
  return axios({
    url: `${base}/CECClosed`,
    method: 'POST',
    headers: await getHeaders(),
    data: {
      cec_session_id: getSession()
    }
  });
};

export const encrypt = async data => {
  return axios({
    url: `${base}/encrypt`,
    method: 'POST',
    data: {
      ...data
    }
  });
};

export const getJsonFile = async filePath => {
  return axios({
    url: `${filePath}`,
    method: 'GET'
  });
};

export const postSimpleUIEvents = async events => {
  return axios({
    url: `${base}/events`,
    method: 'POST',
    data: events
  });
};

export const getSplunkAppConfigData = async () => {
  return axios({
    url: `${base}/splunk/rum-token`,
    method: 'GET'
  });
};
